import React from 'react'

import styles from './styles.module.scss'

function NotFoundDisclosure() {
  return <span className={styles.error}>DISCLOSURE NOT FOUND</span>
}

export default NotFoundDisclosure
